export default [
  {
    path: '/admin/apply/system/settings',
    name: 'SystemSettings',
    component: () => import('@/views/apply/system/settings'),
    meta: {
      title: '系统设置',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/paymentSettings',
    name: 'PaymentSettings',
    component: () => import('@/views/apply/system/payment_settings'),
    meta: {
      title: '支付设置',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/smsSettings',
    name: 'ApplySystemSmsSettings',
    component: () => import('@/views/apply/system/sms_settings'),
    meta: {
      title: '短信设置',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/customerServiceSettings',
    name: 'CustomerServiceSettings',
    component: () => import('@/views/apply/system/customer_service_settings'),
    meta: {
      title: '客服设置',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/shopSettings',
    name: 'ShopSettings',
    component: () => import('@/views/apply/system/shop_settings'),
    meta: {
      title: '商城设置',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/power',
    name: 'Power',
    component: () => import('@/views/apply/system/power'),
    meta: {
      title: '权限管理',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/system.js